import { z } from "zod";

export const getWeeklyOrganizationPlansParam = z.object({
	week: z.string(),
});

export type GetWeeklyOrganizationPlansParamSchema = z.infer<typeof getWeeklyOrganizationPlansParam>;
